const doc = [({"en":({"activerecord":({"attributes":({"number_of_students_csv":({"file":"File"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;